import React from 'react';
import { deliveryHeader } from '../helpers/headerNameHelpers';

const DeliveryTitle = ({ record }) => {
	return <span>{deliveryHeader(record)}</span>;
};

export default DeliveryTitle;
